// Scrivener's comment colours as inks (`ScrivenerCommentColor`, SuiteImport: the same rule, so both apps make the same
// categories from one project). A comment's `Color` in `content.comments` is "r g b" (0–1, sometimes with an alpha);
// the hue picks the ink, a washed-out colour is grey, and the default yellow — the colour of every comment nobody
// coloured — is null: no category.
import type { InkColor } from '../contract.ts';

export function scrivenerCommentInk(color: string | null | undefined): InkColor | null {
  if (!color) return null;
  const parts = color.split(/[ ,]+/).filter(Boolean).map(Number);
  if (parts.length < 3 || parts.slice(0, 3).some((n) => Number.isNaN(n))) return null;
  const [r, g, b] = parts.slice(0, 3).map((n) => Math.min(Math.max(n, 0), 1));
  const hi = Math.max(r, g, b), lo = Math.min(r, g, b);
  if (hi <= 0) return 'grey';
  if ((hi - lo) / hi < 0.18) return 'grey';
  let hue = hi === r ? 60 * ((g - b) / (hi - lo)) : hi === g ? 60 * (2 + (b - r) / (hi - lo)) : 60 * (4 + (r - g) / (hi - lo));
  if (hue < 0) hue += 360;
  if (hue < 15 || hue >= 345) return 'red';
  if (hue < 45) return 'orange';
  if (hue < 75) return null;
  if (hue < 170) return 'green';
  if (hue < 260) return 'blue';
  if (hue < 300) return 'purple';
  return 'pink';
}

/** The category's name for an ink: the ink's name capitalised ("Red"), as `InkColor.name` on the Mac. */
export const inkCategoryName = (ink: InkColor) => ink.charAt(0).toUpperCase() + ink.slice(1);
